import React from "react";
import { styled, css } from "styled-components";
import Colors from "../../styles/Colors";
import { rem } from "../../utils/rem";
const StyledBlankCard = styled.div `
  color: ${Colors.BLACK};
  background: ${Colors.WHITE};
  border: 1px solid ${Colors.GRAY};
  border-radius: 5px;
  ${({ fullWidth }) => !fullWidth &&
    css `
      max-width: ${rem(320)};
    `}
  ${({ fullWidth }) => fullWidth &&
    css `
      width: 100%;
    `}
`;
const ContentWrapper = styled.div `
  padding: ${rem(24)} ${rem(20)};
`;
export const EmptyCard = ({ header = null, fullWidth, children, }) => (React.createElement(StyledBlankCard, { fullWidth: fullWidth },
    header && header,
    React.createElement(ContentWrapper, null, children)));
export default EmptyCard;
//# sourceMappingURL=EmptyCard.js.map